<template>
    <div class="d-flex space-x-1 align-items-center">
        <div class="d-flex align-items-center font-extrabold text-gray-700 text-sm cursor-pointer">A<div
                class="flex flex-col items-start">
                <div class="px-2">
                    <div class="border border-gray-300 rounded flex relative"><input type="color"
                            class="m-1.5 d-block noborder w-4 h-4 cursor-pointer box-content rounded-full border-0  "
                            :style="{ 'background-color': bgColor }" @input="setTextColor($event)"
                            @change="setTextColor($event)" :value="bgColor">
                        <div class="p-1 border-top-0 d-flex justify-content-center align-items-center border-left">
                            <svg
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="cursor-pointer">
                                <path d="M13.0016 3L3 13M3 3L13.0016 13" stroke="#495057" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mr-2">
            <select name="fontFamily" @change="changeFontFamily($event)" :value="fontFamily" class="form-control form-control-sm w-250 ">
                <option  v-for="(item,index) in fontsList" v-bind:key="item.value + '_' + index" :style="{fontFamily:item.value}" :value="item.value">{{item.name}}</option>
            </select>
        </div>
        <div class="mr-2">
            <select name="fw" @change="changeFW($event)" :value="fw" class="form-control form-control-sm w-250 ">
                <option  v-for="(item,index) in this.getFontWeightList" v-bind:key="item.value + '_' + index" :style="{fontFamily:item.value}" :value="item.value">{{item.name}}</option>
            </select>
           
        </div>  

        <div class="d-flex space-x-1 align-items-center mr-2">
            <div @click="decreaseFontSize"
                class="bg-gray-100 active cursor-pointer font-weight-bold h-6 rounded text-blue-600 text-center text-lg w-6 leading-tight select-none">
                -</div>
            <div class="d-flex mx-2"><input
                    class="w-10 border border-gray-300 rounded text-gray-700 text-sm font-weight-bold h-8 text-center"
                    @change="setFontSizeonInput($event)" :value="fontSize"></div>
            <div @click="increaseFontSize"
                class="bg-gray-100 cursor-pointer font-weight-bold h-6 rounded text-blue-600 text-center text-lg w-6 leading-tight select-none">
                +</div>
        </div>
        <div @click="setTextbold" data-state="tooltip-hidden" data-reach-tooltip-trigger=""
            :class="`textforms ${isBold === true ? 'active' : ''} bg-blue-100 text-blue-600 cursor-pointer rounded p-2 p-1.5 h-7`">
            <div class=" font-weight-bold w-4 h-4 text-sm text-center leading-4">B</div>
        </div>
        <div @click="setTextItalic" data-state="tooltip-hidden" data-reach-tooltip-trigger=""
            :class="`textforms ${isItalic === true ? 'active' : ''} text-gray-700 cursor-pointer rounded mx-1 p-2 p-1.5 h-7`">
            <div class="font-italic font-weight-bold w-4 h-4 text-sm text-center leading-4">I</div>
        </div>
        <div @click="setTextUnderline" data-state="tooltip-hidden" data-reach-tooltip-trigger=""
            :class="`textforms ${isUnderline === true ? 'active' : ''} text-gray-700 cursor-pointer rounded p-2 p-1.5 h-7`">
            <div class="underline font-weight-bold w-4 h-4 text-sm text-center leading-4">U</div>
        </div>

        <div class="hidden d-flex space-x-1 mr-2" @click="setTextAlign">
            <div v-if="textAlign === 'left'"
                class="text-gray-700  text-blue-600 rounded cursor-pointer p-1"><svg width="24" height="24"
                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                    <path d="M4 12H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                    <path d="M4 17H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                </svg></div>
            <div v-else-if="textAlign === 'center'"
                class="text-gray-700  rounded cursor-pointer  p-1"><svg width="24" height="24" viewBox="0 0 24 24"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                    <path d="M7 12H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                    <path d="M4 17H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                </svg></div>
            <div v-else class="text-gray-700 rounded cursor-pointer  p-1"><svg width="24" height="24"
                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                    <path d="M11 12H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                    <path d="M4 17H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
                </svg></div>
        </div>
        <div class="hidden d-flex">
            <div @click="uppercase" class=" text-gray-700 cursor-pointer rounded p-1.5 h-7" v-b-tooltip.hover.bottom="`UPPER CASE`">
                <div class=" font-weight-bold w-4 h-4 text-sm text-center leading-4">TT</div>
            </div>
            <div @click="lowercase" class=" text-gray-700 cursor-pointer rounded p-1.5 mx-3 h-7" v-b-tooltip.hover.bottom="`lower case`">
                <div class=" font-weight-bold w-4 h-4 text-sm text-center leading-4">tt</div>
            </div>
            <div @click="camelCase" class=" text-gray-700 cursor-pointer rounded p-1.5 h-7" v-b-tooltip.hover.bottom="`Capital case`">
                <div class=" font-weight-bold w-4 h-4 text-sm text-center leading-4">Tt</div>
            </div>
        </div>
    </div>
</template>

<script>
import {Fontfamilies} from "../../commonJSON";
export default {
    name: "TextToolbar",
    data() {
        return {
            textAlign: "center",
            bgColor: "",
            fontSize: "",
            isBold: false,
            isItalic: false,
            fontFamily:'arial',
            fw:400,
            fontsList:Fontfamilies,
            isUnderline: false
        }
    },

    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
        getActiveCanvasObject() {
            return this.$store.getters.getActiveObject
        },
        getObjectFIll() {
            return this.$store.getters.getActiveObject.fill
        },
        getActiveObjProps(){
            return this.$store.getters.getActiveObjectProps;
        },
        getObjects(){
            return this.$store.getters.getCurrentActiveCanvasObjects
        },
        getActiveObjectProps(){
          return this.$store.getters.getActiveObjectprops
        },
        getFontWeightList(){
           let newRec =  this.fontsList.find(x => x.name === this.fontFamily);
           return newRec.fw
           
        }

        

    },
    watch: {
        "$store.state.activeObjectprops" : {
            handler(updatedValues) {
                
        
                    console.log("fill updated")
                this.bgColor = updatedValues.color;
                this.fontSize = updatedValues.fs;
                this.isBold = updatedValues.fw > 500 ? true : false;
                this.isItalic = updatedValues.italic ;
                this.isUnderline = updatedValues.underline;
                this.textAlign = updatedValues.align;
                this.fontFamily = updatedValues.fontfamily;
                this.fw = updatedValues.fw;
               console.log("%c Tariq Copy This:" , 'background:#000,color:yellow')
               console.log(updatedValues)
            },
            deep: true,
            immediate: true

        }
       
    },
    methods: {
    
        setTextAlign() {
            
            let obj = this.getActiveObjectProps;
            
            if (obj.align === "center") {
                this.textAlign = "right";
                this.$store.dispatch("setCurrentObjectProperties" , { align: "right" });
            } else if (obj.align === "right") {
                this.textAlign = "left";
                this.$store.dispatch("setCurrentObjectProperties" , { align: "left" });
            } else {
                this.textAlign = "center";
                this.$store.dispatch("setCurrentObjectProperties" , { align: "center" });
            }

        },
        setTextColor(e) {
            let value = e.target.value;
            console.log(value)
                console.log(value)
                this.bgColor = value;
                this.$store.dispatch("setCurrentObjectProperties" , { color: value });
        },

        increaseFontSize() {
    
            this.$store.dispatch("setCurrentObjectProperties" , { fs: this.fontSize + 1 });
            this.fontSize = this.fontSize + 1;

        },
        decreaseFontSize() {
            this.$store.dispatch("setCurrentObjectProperties" , { fs: this.fontSize - 1 });
            this.fontSize = this.fontSize - 1;
        },
        setFontSizeonInput(e) {
            let value = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { fs:  parseInt(value) });
            this.fontSize = parseInt(value);

        },
        setTextbold() {
            let obj = this.getActiveObjectProps;
            if (obj.fw > 500) {
                this.$store.dispatch("setCurrentObjectProperties" , { fw:  parseInt(500) });
                this.isBold = parseInt(500);
            } else {
                this.$store.dispatch("setCurrentObjectProperties" , { fw:  parseInt(700) });
                this.isBold = parseInt(700);
            }

        },
        setTextItalic() {
            let obj = this.getActiveObjectProps;
            if (obj.italic === true) {
                this.$store.dispatch("setCurrentObjectProperties" , { italic:  false });
                this.isItalic = "normal";
            } else {
                this.$store.dispatch("setCurrentObjectProperties" , { italic:  true });
                this.isItalic = "italic";
            }

        },
        setTextUnderline() {
            let obj = this.getActiveObjectProps;
            if (obj.underline === true) {
                this.$store.dispatch("setCurrentObjectProperties" , { underline:  false });
                this.isUnderline = false;
            } else {
                this.$store.dispatch("setCurrentObjectProperties" , { underline:  true });
                this.isUnderline = true;
            }
        },
        uppercase() {
            let active = this.getActiveObjectProps;
            if (!active) return;

            // var text = active.text;
            // this.$store.dispatch("setCurrentObjectProperties" , { text:  [text[0].toUpperCase()] });
            this.$store.dispatch("setCurrentObjectProperties" , { textTransform:  "uppercase" });

        },

        titleCase(str) {
            var splitStr = str.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                // You do not need to check if i is larger than splitStr length, as your for does that for you
                // Assign it back to the array
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            }
            // Directly return the joined string
            return splitStr.join(' ');
        },

        lowercase() {

            let active = this.getActiveObjectProps;
            if (!active) return;

            // var text = active.text;
            // this.$store.dispatch("setCurrentObjectProperties" , { text:  [text[0].toLowerCase()] });
            this.$store.dispatch("setCurrentObjectProperties" , { textTransform:  "lowercase" });

        },

        camelCase() {
           

            let active = this.getActiveObjectProps;
            if (!active) return;

            // var text = active.text;
            // var camelSentences = this.titleCase(text[0]);
            // this.$store.dispatch("setCurrentObjectProperties" , { text:  [camelSentences] });
            this.$store.dispatch("setCurrentObjectProperties" , { textTransform:  "capitalize" });
        },

        changeFontFamily(e){
            let value = e.target.value;
           
            this.$store.dispatch("setCurrentObjectProperties" , { fontfamily:  value });


        },
        changeFW(e){
            debugger // eslint-disable-line no-debugger
            let value = e.target.value;
            if(e.target.selectedOptions[0].text.includes("Italic")){
                this.$store.dispatch("setCurrentObjectProperties" , { italic:  true });
            } else{
                this.$store.dispatch("setCurrentObjectProperties" , { italic:  false });
                
            }
            this.$store.dispatch("setCurrentObjectProperties" , { fw:  value });


        }

    }
}


</script>
<style scoped>
.w-10 {
    width: 2.5rem;
}

.leading-4 {
    line-height: 1rem;
}

.flex {
    display: flex;
}

.underline {
    text-decoration: underline;
}

.noborder::-webkit-color-swatch {
    border: none;
}

.h-8 {
    height: 2rem;
}

.w-6 {
    width: 1.5rem;
}

.h-6 {
    height: 1.5rem;
}

.leading-tight {
    line-height: 1.25;
}

.bg-gray-100 {
    background-color: rgb(248 249 250);
}

.w-4 {
    width: 1rem;
}

.h-4 {
    height: 1rem;
}

.m-1\.5 {
    margin: .375rem;
}

.rounded-full {
    border-radius: 9999px;
}

.textforms.active {
    background-color: rgb(236 239 253);
    padding: .375rem;
    color: rgb(66 99 235);

}

.text-gray-700 {
    color: rgb(73 80 87);
}

.text-gray-500 {
    color: rgb(172 181 189);
}
</style>